const BOOTSTRAP_REGISTRY = new Set();

function runGuarded(pageKey, initFn) {
  if (BOOTSTRAP_REGISTRY.has(pageKey)) return;
  BOOTSTRAP_REGISTRY.add(pageKey);
  Promise.resolve()
    .then(initFn)
    .catch((error) => {
      console.error(`[bootstrap:${pageKey}] failed`, error);
    });
}

export function runPageBootstrap(pageKey, initFn, options = {}) {
  const { waitForDom = true } = options;
  if (!pageKey || typeof initFn !== 'function') return;

  if (!waitForDom) {
    runGuarded(pageKey, initFn);
    return;
  }

  if (typeof document === 'undefined') {
    runGuarded(pageKey, initFn);
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runGuarded(pageKey, initFn), { once: true });
  } else {
    runGuarded(pageKey, initFn);
  }
}

